// import { Component, OnInit, Input } from '@angular/core';

// import { I18nService } from './i18n.service';

// @Component({
//   selector: 'app-language-selector',
//   templateUrl: './language-selector.component.html',
//   styleUrls: ['./language-selector.component.scss'],
// })
// export class LanguageSelectorComponent implements OnInit {
//   @Input() inNavbar = false;
//   @Input() menuClass = '';

//   languageMap: { [key: string]: string } = {
//     EN: 'EN (English)',
//     FR: 'FR (French)',
//     DE: 'DE (German)',
//     IT: 'IT (Italian)',
//     ES: 'ES (Spanish)',
//     PT: 'PT (Portuguese)',
//     RU: 'RU (Russian)',
//     ZH: 'ZH (Simplified Chinese)',
//     AR: 'AR (Arabic)',
//     HI: 'HI (Hindi)',
//     JA: 'JA (Japanese)',
//   };
//   public displayLanguages: any[];

//   constructor(private i18nService: I18nService) { }

//   ngOnInit() {
//     this.updateDisplayLanguages();
//   }

//   ngDoCheck() {
//     if (
//       this.i18nService.supportedLanguages &&
//       (!this.displayLanguages || this.displayLanguages.length !== this.i18nService.supportedLanguages.length)
//     ) {
//       this.updateDisplayLanguages();
//     }
//   }

//   private updateDisplayLanguages() {
//     if (this.i18nService.supportedLanguages) {
//       this.displayLanguages = this.i18nService.supportedLanguages.map((code) => ({
//         code,
//         displayName: this.languageMap[code] || code,
//       }));
//       //console.log('Updated displayLanguages:', this.displayLanguages);
//     } else {
//       this.displayLanguages = [];
//     }
//   }

//   setLanguage(language: string) {
//     try {
//       localStorage.setItem('language', language);
//       this.i18nService.language = language;
//       window.location.reload();
//     } catch (error) { }
//   }

//   get currentLanguage(): string {
//     return this.languageMap[this.i18nService.language] || this.i18nService.language;
//   }

//   get languages(): any[] {
//     return this.i18nService.supportedLanguages.map((code) => ({
//       code,
//       displayName: this.languageMap[code] || code,
//     }));
//   }
// }

// i18n language

import { Component, OnInit, Input, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { I18nService } from './i18n.service';

@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
})
export class LanguageSelectorComponent implements OnInit {
  @Input() inNavbar = false;
  @Input() menuClass = '';

  languageMap: { [key: string]: string } = {
    EN: 'EN (English)',
    FR: 'FR (French)',
    DE: 'DE (German)',
    IT: 'IT (Italian)',
    ES: 'ES (Spanish)',
    PT: 'PT (Portuguese)',
    RU: 'RU (Russian)',
    ZH: 'ZH (Simplified Chinese)',
    AR: 'AR (Arabic)',
    HI: 'HI (Hindi)',
    JA: 'JA (Japanese)',
  };
  public displayLanguages: any[];

  constructor(private i18nService: I18nService, @Inject(DOCUMENT) private document: Document) {}

  ngOnInit() {
    this.updateDisplayLanguages();

    // Ensure direction is set immediately on component initialization
    const currentLang = localStorage.getItem('language') || this.i18nService.language || 'EN';
    this.setDocumentDirection(currentLang);
  }

  ngDoCheck() {
    if (
      this.i18nService.supportedLanguages &&
      (!this.displayLanguages || this.displayLanguages.length !== this.i18nService.supportedLanguages.length)
    ) {
      this.updateDisplayLanguages();
    }
  }

  private updateDisplayLanguages() {
    if (this.i18nService.supportedLanguages) {
      this.displayLanguages = this.i18nService.supportedLanguages.map((code) => ({
        code,
        displayName: this.languageMap[code] || code,
      }));
    } else {
      this.displayLanguages = [];
    }
  }

  /**
   * Helper to set document direction (ltr/rtl) and lang attribute dynamically
   */
  private setDocumentDirection(lang: string) {
    if (!lang) return;
    const direction = lang.toLowerCase() === 'ar' ? 'rtl' : 'ltr';
    this.document.documentElement.setAttribute('dir', direction);
    this.document.documentElement.setAttribute('lang', lang.toLowerCase());
  }

  setLanguage(language: string) {
    try {
      localStorage.setItem('language', language);
      this.i18nService.language = language;

      // Update direction right before reload
      this.setDocumentDirection(language);

      window.location.reload();
    } catch (error) {
      console.error('Error setting language:', error);
    }
  }

  get currentLanguage(): string {
    return this.languageMap[this.i18nService.language] || this.i18nService.language;
  }

  get languages(): any[] {
    return this.i18nService.supportedLanguages.map((code) => ({
      code,
      displayName: this.languageMap[code] || code,
    }));
  }
}
